module.exports = __webpack_public_path__ + "static/media/12_before.23005317.jpg";